"use client";

import { SidebarTrigger } from "@/components/ui/sidebar";
import { TopNavActions } from "./TopNavActions";
import { TopNavSearch } from "./TopNavSearch";

export function AppTopNav() {
  return (
    <header className="flex h-16 items-center justify-between gap-4 border-b border-neutral-slate-200 bg-white px-6">
      <div className="flex items-center gap-3">
        <SidebarTrigger className="text-neutral-500 hover:bg-neutral-100 hover:text-neutral-700 md:hidden" />
      </div>
      <div className="flex flex-1 justify-center">
        <TopNavSearch />
      </div>
      <TopNavActions />
    </header>
  );
}
